import { render, staticRenderFns } from "./orderHistoryIcon.vue?vue&type=template&id=40ea33ef&"
import script from "./orderHistoryIcon.vue?vue&type=script&lang=js&"
export * from "./orderHistoryIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports